import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import {
  SortByOptions,
  type SortByType,
} from "@/components/review-modal/types";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { ChevronIcon } from "./icons";

export const DEFAULT_SORT = SortByOptions.DATE_REVIEWED;

export const SORT_OPTIONS = {
  // [SortByOptions.RELEVANCE]: 'Relevance',
  [SortByOptions.DATE_REVIEWED]: "Review date",
  [SortByOptions.DATE_PLAYED]: "Date of visit",
  [SortByOptions.SCORE]: "Score",
};

interface SortMenuProps {
  path: string[];
  selected: SortByType;
}

export default function SortMenu({ path, selected }: SortMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const cleanPath = path.filter((s) => !s.startsWith("reviews:"));

  const getSortUrl = (s: string) => {
    const u = [...cleanPath];
    u.push(`reviews:sort:${s}`);
    return `/${u.join("/")}`;
  };

  const handleClick = (key: string) => () => {
    navigate({ replace: true, to: getSortUrl(key) });
    setIsOpen(false);
  };

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger className="flex h-7.5 items-center gap-2 rounded-[15px] bg-deep-cove-light px-2.5 font-medium text-13 text-white shadow-0-0-4 shadow-black/30 data-[state=open]:[&>svg]:rotate-180">
        {SORT_OPTIONS[selected]}
        <ChevronIcon className="transition-transform" />
      </PopoverTrigger>
      <PopoverContent
        align="end"
        asChild
        className="w-auto flex-col rounded-[15px] border-0 bg-deep-cove-dark px-0 py-2"
      >
        <ul>
          {Object.entries(SORT_OPTIONS).map(([key, value]) => (
            <li key={key}>
              <Button
                className="py-[5px] pr-7.5 pl-3.5 font-medium text-13/[1.2em] text-white hover:underline"
                onClick={handleClick(key)}
                variant="link"
              >
                {value}
              </Button>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
